import Vue from 'vue';
import Vuex from 'vuex';
import Inject from 'vue-inject';
import { store as dycolor } from 'gotu-vue-dycolor';
import { DEFAULT_COLORS } from '@/util/constants';

Vue.use(Vuex);

const originalContext = require.context('./modules/', false, /\.js$/);
const modules = (context) => {
  const res = {};
  context.keys().map(k => res[k.slice(2, -3)] = context(k).default);

  res.dycolor = dycolor(DEFAULT_COLORS);

  return res;
};

const store = new Vuex.Store({
  strict: true,
  modules: modules(originalContext),
});

Inject.constant('$store', store);

export default store;

if (module.hot) {
  module.hot.accept(originalContext.id, () => {
    store.hotUpdate({ modules: modules(require.context('./modules/', false, /\.js$/)) });
  });
}



// WEBPACK FOOTER //
// ./src/store/index.js